<template>
  <div></div>
</template>

<script>
import apiClientCreator from "../../../../helpers/api/request";

export default {
  name: "AvgDailyCharts.component",
  props: {
    selectedTimeFrame: {
      type: Number,
      required: true
    },
    selectedTier: {
      required: true
    },
    selectedFilter: {
      required: true
    }
  },
  data() {
    return {
      avgStats: []
    };
  },
  mounted() {
    apiClientCreator(`reports/timely_report/average_report/volatility`)
      .get("", {})
      .then(res => {
        this.avgStats = res.data;
      });
  }
};
</script>

<style scoped></style>
